const saladesData = [
    {
        title: "Du chef",
        image: require("../image/salade/salade-duchef.png"),
        paragraphe: "Salade verte, tomates, lardons, chèvre chaud, toast",
        price: "saladeprice",
    },
    {
        title: "Mixte",
        image: require("../image/salade/salade-mixte.png"),
        paragraphe: "Salade verte, tomates, olives",
        price: "saladepricemixte",
    },
    {
        title: "Niçoise",
        image: require("../image/salade/salade-nicoise.png"),
        paragraphe: "Salade verte, tomates, thon, olives, pommes de terre",
        price: "saladeprice",
    },
    {
        title: "Provençale",
        image: require("../image/salade/salade-provencale.png"),
        paragraphe: "Salade verte, tomates, chèvre, poulet fumé, olives",
        price: "saladeprice",
    },
    {
        title: "Saumon fumé",
        image: require("../image/salade/salade-saumon.png"),
        paragraphe: "Salade verte, tomates, saumon fumé, olives",
        price: "saladeprice",
    },
];

export default saladesData;
